import classNames from "classnames";

export const SwitchButton = ({
  value,
  options,
  onChange,
  btnMinWidth
}: {
  value: string;
  options: { value: string; label: string }[];
  onChange: (val: string) => void;
  btnMinWidth?: number;
}) => {
  return (
    <div className="flex items-center bg-[#F8FAFC] rounded-lg">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={classNames(
            "cursor-pointer border-none text-sm rounded-lg px-3 py-2",
            value === option.value
              ? "bg-[#E6F6FE] text-[#167EF9]"
              : "bg-[#F8FAFC] text-[#64748B]",
            btnMinWidth && `min-w-[${btnMinWidth}px]`
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
